// SL.L3a (#2959) — GET/PUT /projects/:projectId/sprint-config
// (routes/sprints.ts): the project's limit on active sprints.
import { apiFetch } from './api';

export interface SprintConfig {
  maxActiveSprints: number;
  /** True when the project has no stored value (the limit is then 1). */
  isDefault: boolean;
  /** Sprints active now. May exceed the limit after it is lowered (ruling D6). */
  activeSprints: number;
  allowedActions: string[];
}

const configPath = (projectId: string) => `/projects/${encodeURIComponent(projectId)}/sprint-config`;

export function fetchSprintConfig(projectId: string): Promise<SprintConfig> {
  return apiFetch<SprintConfig>(configPath(projectId));
}

export function putSprintConfig(projectId: string, maxActiveSprints: number): Promise<SprintConfig> {
  return apiFetch<SprintConfig>(configPath(projectId), { method: 'PUT', body: JSON.stringify({ maxActiveSprints }) });
}
